import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
	GET_USER_PERMISSIONS,
	GET_LOCATIONS,
	GET_SUB_LOCATIONS,
	SUB_ORDER_LOCATIONS_LIST,
	GET_USER_LOCATIONS,
	GET_USER_SUB_LOCATIONS,
	GET_DEPARTMENT,
	GET_USER_DEPARTMENT,
	GET_STATE,
	GET_VENDORS,
	GET_VENDORS2,
	GET_SECTION,
	GET_CATEGORY,
	GET_TAX,
	GET_BASICUNIT,
	GET_MINI_PRODUCT_GROUPS_LIST,
	GET_SUBLOCATIONS2,
	GET_MINI_PRODUCT_LIST,
	MINI_SUB_ORDER_LOCATIONS_LIST,
	GET_ProductQualities,
	GET_MINI_QUALITY_LIST,
} from "./actionTypes";
import {
	apiError,
	userPermissionsSuccessful,
	locationListSuccessful,
	sublocationListSuccessful,
	userLocationListSuccessful,
	userSubLocationListSuccessful,
	suborderlocationListSuccessful,
	DepartmentListSuccessful,
	UserDepartmentListSuccessful,
	stateListSuccessful,
	vendorListSuccessful,
	vendor2ListSuccessful,
	SectionListSuccessful,
	CategoryListSuccessful,
	TaxListSuccessful,
	BasicUnitListSuccessful,
	ProductMiniGroupsListSuccessful,
	sub2LocationSuccessful,
	ProductMiniListSuccessful,
	minisuborderlocationListSuccessful,
	productQualitiesistSuccessful,
	QUALITYListSuccessful,
} from "./actions";

// AUTH related methods
import { addParams, getList, getParamsList } from "../../helpers/Helper";
function* getUserPermissions() {
	try {
		const response = yield call(getList, "/users/userpermissions/", {});
		yield put(userPermissionsSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getLocation() {
	try {
		const response = yield call(getList, "/masters/mini/locations/", {});
		yield put(locationListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getSubLocation({ payload: { id } }) {
	try {
		const response = yield call(
			getList,
			"/masters/mini/sublocations/location/" + id,
			{}
		);
		yield put(sublocationListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getSubOrderLocation({ payload: { location_id, sublocation_id } }) {
	try {
		const response = yield call(
			getList,
			"/masters/mini/orderlocations/location/" +
				location_id +
				"/sublocation/" +
				sublocation_id +
				"/",
			{}
		);
		yield put(suborderlocationListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getSubOrderLocations() {
	try {
		const response = yield call(
			getList,
			"/masters/mini/orderlocations/",
			{}
		);
		yield put(minisuborderlocationListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getproductQualitiesistSuccessful({ payload }) {
	console.log("[Mini Saga] getproductQualitiesistSuccessful - START");
	console.log("[Mini Saga] payload received:", payload);
	try {
		console.log("[Mini Saga] Making API call to /masters/mini/productqualities/");
		const response = yield call(
			getParamsList,
			"/masters/mini/productqualities/",
			payload
		);
		console.log("[Mini Saga] API response received:", response);
		yield put(
			productQualitiesistSuccessful({
				response: response,
				params: payload,
			})
		);
		console.log("[Mini Saga] Action dispatched successfully");
	} catch (error) {
		console.log("[Mini Saga] Error caught:", error);
		yield put(apiError(error));
	}
}
function* getUserLocation() {
	try {
		const response = yield call(
			getList,
			"/masters/mini/user/locations/",
			{}
		);
		yield put(userLocationListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getUserSubLocation({ payload: { id } }) {
	try {
		const response = yield call(
			getList,
			"/masters/mini/user/sublocations/location/" + id,
			{}
		);
		yield put(userSubLocationListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getDepartment() {
	try {
		const response = yield call(getList, "/masters/mini/departments/", {});
		yield put(DepartmentListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getUserDepartment({ payload: { cb } }) {
	try {
		const response = yield call(
			getList,
			"/masters/mini/user/departments/",
			{}
		);
		yield put(UserDepartmentListSuccessful(response));
		if (cb) {
			cb();
		}
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getState() {
	try {
		const response = yield call(getList, "/masters/mini/states/", {});
		yield put(stateListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getVendor({ payload = {} }) {
	try {
		const response = yield call(
			getParamsList,
			"/masters/mini/vendors/",
			payload
		);

		yield put(vendorListSuccessful(response, payload));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getVendor2() {
	try {
		const response = yield call(getList, "/masters/mini2/vendors/", {});
		yield put(vendor2ListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getSubLocations2({ payload: { data } }) {
	try {
		const response = yield call(
			getParamsList,
			"/masters/mini2/sublocations/",
			data,
			{}
		);
		yield put(sub2LocationSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getSection() {
	try {
		const response = yield call(getList, "/masters/mini/sections/", {});
		yield put(SectionListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getCategory() {
	try {
		const response = yield call(getList, "/masters/mini/categorys/", {});
		yield put(CategoryListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getTax() {
	try {
		const response = yield call(getList, "/masters/mini/taxs/", {});
		yield put(TaxListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getBasicUnit() {
	try {
		const response = yield call(getList, "/masters/mini/baseunits/", {});
		yield put(BasicUnitListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getMiniPGroupList() {
	try {
		const response = yield call(getList, "/masters/mini/pgroups/", {});
		yield put(ProductMiniGroupsListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getMiniQUALITYList({ payload }) {
	try {
		const response = yield call(
			getParamsList,
			"/masters/mini/quality/",
			payload
		);
		
		// yield put(QUALITYListSuccessful(response, payload));
		yield put(QUALITYListSuccessful({ response, params: payload }));
		// ✅ Correct
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getMiniProductsList({ payload }) {
	try {
		const response = yield call(
			getParamsList,
			"/masters/mini/products/",
			payload
		);
		yield put(
			ProductMiniListSuccessful({ response: response, params: payload })
		);
	} catch (error) {
		yield put(apiError(error));
	}
}

export function* watchGetUserPermissions() {
	yield takeEvery(GET_USER_PERMISSIONS, getUserPermissions);
}
export function* watchGetLocattions() {
	yield takeEvery(GET_LOCATIONS, getLocation);
}
export function* watchGetSubLocattions() {
	yield takeEvery(GET_SUB_LOCATIONS, getSubLocation);
}

export function* watchGetSubOrderLocattions() {
	yield takeEvery(SUB_ORDER_LOCATIONS_LIST, getSubOrderLocation);
}

export function* watchGetMiniSubOrderLocattions() {
	yield takeEvery(MINI_SUB_ORDER_LOCATIONS_LIST, getSubOrderLocations);
}

export function* watchGetProductQualitiesistSuccessful() {
	yield takeEvery(GET_ProductQualities, getproductQualitiesistSuccessful);
}
export function* watchGetDepartments() {
	yield takeEvery(GET_DEPARTMENT, getDepartment);
}
export function* watchGetUserLocattions() {
	yield takeEvery(GET_USER_LOCATIONS, getUserLocation);
}
export function* watchGetUserSubLocattions() {
	yield takeEvery(GET_USER_SUB_LOCATIONS, getUserSubLocation);
}
export function* watchGetUserDepartments() {
	yield takeEvery(GET_USER_DEPARTMENT, getUserDepartment);
}
export function* watchgetVendors() {
	yield takeEvery(GET_VENDORS, getVendor);
}
export function* watchgetVendors2() {
	yield takeEvery(GET_VENDORS2, getVendor2);
}

export function* watchgetSubLocations2() {
	yield takeEvery(GET_SUBLOCATIONS2, getSubLocations2);
}

export function* watchgetState() {
	yield takeEvery(GET_STATE, getState);
}
export function* watchgetSection() {
	yield takeEvery(GET_SECTION, getSection);
}
export function* watchgetCategory() {
	yield takeEvery(GET_CATEGORY, getCategory);
}
export function* watchgetTax() {
	yield takeEvery(GET_TAX, getTax);
}
export function* watchgetBasicUnit() {
	yield takeEvery(GET_BASICUNIT, getBasicUnit);
}
export function* watchgetMiniPGroupList() {
	yield takeEvery(GET_MINI_PRODUCT_GROUPS_LIST, getMiniPGroupList);
}
export function* watchgetMiniProductsList() {
	yield takeEvery(GET_MINI_PRODUCT_LIST, getMiniProductsList);
	//yield takeLatest(GET_MINI_PRODUCT_LIST, getMiniProductsList);
}

export function* watchgetMiniQualityList() {
	yield takeEvery(GET_MINI_QUALITY_LIST, getMiniQUALITYList);
	//yield takeLatest(GET_MINI_PRODUCT_LIST, getMiniProductsList);
}

function* miniSaga() {
	yield all([
		fork(watchGetUserPermissions),
		fork(watchGetLocattions),
		fork(watchGetSubLocattions),
		fork(watchGetDepartments),
		fork(watchGetUserLocattions),
		fork(watchGetUserSubLocattions),
		fork(watchGetUserDepartments),
		fork(watchgetState),
		fork(watchgetVendors),
		fork(watchgetVendors2),
		fork(watchgetSubLocations2),
		fork(watchgetSection),
		fork(watchgetCategory),
		fork(watchgetTax),
		fork(watchgetBasicUnit),
		fork(watchgetMiniPGroupList),
		fork(watchgetMiniProductsList),
		fork(watchGetSubOrderLocattions),
		fork(watchGetMiniSubOrderLocattions),
		fork(watchgetMiniQualityList),
		fork(watchGetProductQualitiesistSuccessful),
	]);
}

export default miniSaga;
